import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { File } from "@ionic-native/file";
import { from } from "rxjs/observable/from";
import { fs } from "file-system";
import { Observable } from "rxjs/Observable";
import { AWSEC2 } from '../../environments/environment';
import { FORGECLIENT } from '../../environments/environment';

/*
  Generated class for the RestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RestProvider {
  constructor(public http: HttpClient) {
    console.log("Hello RestProvider Provider");
  }

  static BASE_URL = "https://developer.api.autodesk.com";
  static DA_BASE_URL = "/da/us-east/v3";
  static APP_BUNDLE_URL = 'https://dasprod-store.s3.amazonaws.com';
  // NOINOO
  // public static CLIENT_ID = "b2jPOPMc5xTybXfs21LUrGpCG38tkbqe";
  // static CLIENT_SECRET = "xCyFg5Dl2o9OPF7v";
  // HIGHBIG PRODUCTION !!!!
  // static CLIENT_ID = "lGO4wN3IuPABE3oglfdUZlOfPFItu0X9";
  // static CLIENT_SECRET = "dc8ieAHeTQkzXEKB";
  // Yertonts2
  // static CLIENT_ID = "vAJa81j2xe83ajS7ilpmYfNZVAIjjW5p";
  // static CLIENT_SECRET = "Cn5GDf1ZBpAbcZIZ";
  static scopes =
    "code:all data:write data:read bucket:create bucket:delete bucket:read";
  accessToken = "";
  bucketList = [];
  policyKey = "persistent"; // Expires in 24hr
  bucketKey = FORGECLIENT.CLIENT_ID.toLowerCase() + "_tutorial_bucket_susano"; // Prefix with your ID so the bucket key is unique across all buckets on all other accounts
  // this.bucketKey = RestProvider.CLIENT_ID.toLowerCase() + "_" + new Date().getTime(); // Prefix with your ID so the bucket key is unique across all buckets on all other accounts

  public getAccessToken(type: any): Observable<any> {
    const body = new HttpParams()
      .set("client_id", FORGECLIENT.CLIENT_ID)
      .set("client_secret", FORGECLIENT.CLIENT_SECRET)
      .set("grant_type", "client_credentials")
      .set("scope", RestProvider.scopes);

    let headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    return this.http
      .post(RestProvider.BASE_URL + "/authentication/v1/authenticate", body, {
        headers: headers,
      });
  }

  public setAccessTokenNow(token) {
    this.accessToken = token;
  }

  public getAccessTokenNow(): String {
    return this.accessToken;
  }

  public setBucket(key) {
    this.bucketKey = localStorage.getItem('bucketKey');
  }

  public getBucket(): String {
    return localStorage.getItem('bucketKey');
  }

  public getBuckets(): Observable<any> {
    let headers = {
      "content-type": "application/json",
      Authorization: "Bearer " + this.accessToken,
    };

    return this.http
      .get(RestProvider.BASE_URL + "/oss/v2/buckets", { headers: headers });
  }

  public deleteBucket(key): Observable<any> {
    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.accessToken,
    };
    return this.http
      .delete(RestProvider.BASE_URL + "/oss/v2/buckets/" + key, {
        headers: headers
      });
  }

  public deleteUrn(urn): Observable<any> {
    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.accessToken,
    };
    return this.http
      .delete(RestProvider.BASE_URL + "/modelderivative/v2/designdata/" + urn + '/manifest', {
        headers: headers
      });
  }

  public createBucket(id): Observable<any> {
    
    const body = {
      bucketKey: this.bucketKey + id,
      policyKey: this.policyKey,
    };

    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.accessToken,
    };
    return this.http
      .post(RestProvider.BASE_URL + "/oss/v2/buckets", body, {
        headers: headers,
        observe: "response",
      });    
  }

  public getBucketDetail(bucketKey: string): Observable<any> {
    let headers = {
      Authorization: "Bearer " + this.accessToken,
    };

    return this.http
      .get(
        RestProvider.BASE_URL +
          "/oss/v2/buckets/" +
          encodeURIComponent(bucketKey) +
          "/details",
        { headers: headers }
      );
  }

  uploadObjects(file: File, fileContent: any, contentRange, startingByte, endingByte, sessionId, bucketKey): Observable<any> {
    localStorage.setItem('bucketKey', bucketKey);
    this.bucketKey = bucketKey;
    console.log('bucketkey in rest => ', bucketKey);
    console.log('bucketkey in rest => ', this.bucketKey);
    let headers = {
      Authorization: 'Bearer ' + this.accessToken,
      // 'Content-Disposition': file.name,
      'Content-Length': fileContent.length,
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    
    if(localStorage.getItem('sha1') != null) {
      // headers['If-Match'] = localStorage.getItem('sha1');
    }
    if(contentRange != null) {
      if(endingByte == file.size - 1) {
        var blob = file.slice(startingByte);
      } else {
        var blob = file.slice(startingByte, endingByte + 1);
      }
      console.log(blob.size);
      headers['Session-Id'] = '' + sessionId;
      headers['Content-Range'] = contentRange;
      headers['Content-Length'] = blob.size;
      headers['Content-Type'] = 'application/octet-stream';
      console.log(startingByte, endingByte);
      console.log(contentRange);
      return this.http.put(
        RestProvider.BASE_URL +
          "/oss/v2/buckets/" + encodeURIComponent(bucketKey) +
          "/objects/" + encodeURIComponent(file.name) + "/resumable",
          blob,
          // body,
          /*{
            fileContent,
            maxContentLength: Infinity, 
            maxBodyLength: Infinity
          },*/
        { headers: headers });
    } else {
      return this.http.put(
        RestProvider.BASE_URL +
          "/oss/v2/buckets/" + encodeURIComponent(bucketKey) +
          "/objects/" + encodeURIComponent(file.name),
          file,
          // body,
          /*{
            fileContent,
            maxContentLength: Infinity, 
            maxBodyLength: Infinity
          },*/
        { headers: headers });
    }
  }

  public downloadObject(file: File, fileContent: string): Observable<any> {
    let headers = {
      Authorization:
        "Bearer " +
        "eyJhbGciOiJIUzI1NiIsImtpZCI6Imp3dF9zeW1tZXRyaWNfa2V5In0.eyJzY29wZSI6WyJjb2RlOmFsbCIsImRhdGE6d3JpdGUiLCJkYXRhOnJlYWQiLCJidWNrZXQ6Y3JlYXRlIiwiYnVja2V0OmRlbGV0ZSIsImJ1Y2tldDpyZWFkIl0sImNsaWVudF9pZCI6IjluTDRnZlA5OGZhckRBdEhrbnVsdzd5UlRyZ3NLazdTIiwiYXVkIjoiaHR0cHM6Ly9hdXRvZGVzay5jb20vYXVkL2p3dGV4cDYwIiwianRpIjoiWk1nMDRtbkh3dmFOYkFTTTNBbXRhN2VOc2UzdnJNNmdtNExIRW9ZZWF5MGs3NnAxcnpEc0xoemk3ZFJTNjh4OSIsImV4cCI6MTYwMDkzMjY1OH0.kFuW3B7vNaMFyzaEaB5T1kRFcXYa3rOjSlFllJmOg1I", //this.accessToken
    };
    return this.http.get(
      RestProvider.BASE_URL +
        "/oss/v2/buckets/" +
        encodeURIComponent(this.bucketKey) +
        "/objects/" +
        encodeURIComponent(file.name),
      { headers: headers }
    );
  }

  public containerId(uuid: string): Observable<any> {
    let headers = {
      Authorization: "Bearer " + this.accessToken,
    };
    return this.http.get(
      RestProvider.BASE_URL + "/cost/v1/containers/" + uuid + "/properties",
      { headers: headers }
    );
  }

  public getBucketObjects(bucketKey: string): Observable<any> {
    let headers = {
      Authorization: "Bearer " + this.accessToken,
    };

    return this.http
      .get(
        RestProvider.BASE_URL + "/oss/v2/buckets/" + bucketKey + "/objects",
        { headers: headers }
      );
  }

  public deleteBucketObject(key, name): Observable<any> {
    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.accessToken,
    };
    return this.http
      .delete(RestProvider.BASE_URL + 
        "/oss/v2/buckets/" + key + 
        '/objects/' + name, 
        { headers: headers });
  }

  public getBucketObjectDetail(bucketKey: string, objectKey: string) {
    let headers = {
      Authorization: "Bearer " + this.accessToken,
    };

    return this.http.get(
        RestProvider.BASE_URL +
          "/oss/v2/buckets/" + bucketKey +
          "/objects/" + objectKey +
          "/details",
        { headers: headers });
  }

  public translateObject(urn: string): Observable<any> {
    let headers = {
      "Authorization": "Bearer " + this.accessToken,
      "Content-Type": "application/json",
      "x-ads-force": 'true'//JSON.parse('true')
    };
    // headers['x-ads-force'] = true;

    let headers2 = new HttpHeaders();
    headers2.append('Authorization', "Bearer " + this.accessToken);
    headers2.append('Content-Type', "application/json");
    headers2.append('x-ads-force', 'true');

    var format_type = "svf";
    var format_views = ["2d", "3d"];

    let body = JSON.stringify({
      input: {
        urn: urn,
      },
      output: {
        formats: [
          {
            type: format_type,
            views: format_views,
          },
        ],
      },
    });
    console.log('translate');
    return this.http.post(
      RestProvider.BASE_URL + "/modelderivative/v2/designdata/job",
      body,
      { headers: headers }
    );
  }

  public getLoadUrn(urn: string): Observable<any> {
    let headers = {
      Authorization: "Bearer " + this.accessToken,
      "Content-Type": "application/json",
    };

    return this.http.get(
      RestProvider.BASE_URL + "/derivativeservice/v2/manifest/" + urn + '?domain=http://localhost:8100',
      { headers: headers }
    );
  }

  getHubs(): Observable<any> {
    let headers = {
      Authorization: "Bearer " + this.accessToken,
      
    };
    return this.http.get(RestProvider.BASE_URL + "/project/v1/hubs", {
      headers: headers,
    });
  }

  public getNickName(): Observable<any> {
    return this.http
      .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/forgeapps/me', { headers: { Authorization: "Bearer " + this.accessToken}});
  }

  public deleteNickName(name): Observable<any> {
    return this.http
      .delete(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/forgeapps/me', { headers: { Authorization: "Bearer " + this.accessToken}});
  }

  public setNickName(name): Observable<any> {
    const body = {
      "nickname": name
    }
    return this.http
    .patch(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/forgeapps/me', body, { 
      headers: { Authorization: "Bearer " + this.accessToken },
      observe: 'response'
    });
  }

  public dumpEngines(): Observable<any> {
    return this.http
      .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/engines', { headers: { Authorization: "Bearer " + this.accessToken }});
  }

  public getEngineAttributes(engine) {
    let data = {}; //TODO ene function iig re.search gesen uildel ashiglaj bichsen oilgomjgui
    data['commandLine'] =  "$(engine.path)\\revitcoreconsole.exe /i \"$(args[inputFile].path)\" /al \"$(appbundles[{0}].path)\"";
    data['extension'] = "rvt";
    data['script'] = "";
    return data;
  }

  public getDefinedAppbundles(page): Observable<any> {
    if(page == 1) {
      return this.http
      .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles', { headers: { Authorization: "Bearer " + this.accessToken } });
    } else {
      return this.http
        .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles?page=' + page, { headers: { Authorization: "Bearer " + this.accessToken } });
    }
  }

  public createAppBundle(enginename, appname): Observable<any> {
    let appBundleSpec = {};
    appBundleSpec['id'] = appname;
    appBundleSpec['engine'] = enginename;
    appBundleSpec['description'] = 'Description for ' + appname;

    return this.http
      .post(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles', appBundleSpec , { headers: { Authorization: "Bearer " + this.accessToken }});
  }

  public deleteAppBundle(id): Observable<any> {
    return this.http
      .delete(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles/' + id , { headers: { Authorization: "Bearer " + this.accessToken }});
  }

  public createAppBundleVersion(enginename, appname): Observable<any> {
    let appBundleSpec = {};
    appBundleSpec['engine'] = enginename;
    appBundleSpec['description'] = 'Description for ' + appname;

    return this.http
      .post(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles/' + appname + '/versions', appBundleSpec , {headers:{'Authorization': "Bearer " + this.accessToken}})
  }

  public createAppBundleAlias(appname, alias, version): Observable<any> {
    let aliasSpec = {'version': version,'id':alias}
    return this.http
      .post(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles/' + appname + '/aliases', aliasSpec, {headers:{'Authorization': "Bearer " + this.accessToken}})
  }

  public updateAppBundleAlias(appname, alias, version): Observable<any> {
    let aliasSpec = { 'version' : version }
    return this.http
      .patch(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/appbundles/' + appname + '/aliases/' + alias, aliasSpec, { headers: { Authorization: "Bearer " + this.accessToken }});
  }


  public uploadZip(appname, zipname, fileForm, file, fileContent): Observable<any> {
    // let my_file = ; TODO file iin path iig uusgene 
    let headers = {
      'Content-Type': 'multipart/form-data'
    };
    var formData = new FormData();
    formData.append('content-type', fileForm['content-type']);
    formData.append('key', fileForm['key']);
    formData.append('policy', fileForm['policy']);
    formData.append('success_action_redirect', fileForm['success_action_redirect']);
    formData.append('success_action_status', fileForm['success_action_status']);
    formData.append('x-amz-algorithm', fileForm['x-amz-algorithm']);
    formData.append('x-amz-credential', fileForm['x-amz-credential']);
    formData.append('x-amz-date', fileForm['x-amz-date']);
    formData.append('x-amz-security-token', fileForm['x-amz-security-token']);
    formData.append('x-amz-server-side-encryption', fileForm['x-amz-server-side-encryption']);
    formData.append('x-amz-signature', fileForm['x-amz-signature']);
    // formData = fileForm;
    formData.append('file', fileContent);
    console.log('formData => ', formData);
    // fileForm['file'] = file;
    return this.http.post(
      'https://dasprod-store.s3.amazonaws.com',
        formData
    );
  }

  public getDefinedActivities(page): Observable<any> {
    if(page == 1) {
      return this.http
      .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/activities', { headers: { Authorization: "Bearer " + this.accessToken }});
    } else {
      return this.http
        .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/activities?page=' + page, { headers: { Authorization: "Bearer " + this.accessToken }});
    }
  }

  public createActivity(enginename, appname, qualifiedAppBundleId, actname): Observable<any> {
    let engineAttributes = this.getEngineAttributes(enginename);
    let commandLine = engineAttributes['commandLine'].replace('{0}', appname);
    let activitySpec = {
      'id': actname,
      'engine': enginename,
      'commandLine': [commandLine],
      'appbundles': [qualifiedAppBundleId],
      'description': 'Description for ' + actname,
      'parameters': {
        'inputFile': {
          'verb':'get','description':'','localName':'$(inputFile)','zip':false,'ondemand':false
        },
        'inputJson': {
          'verb':'get','description':'','localName':'params.json','zip':false,'ondemand':false
        },
        'outputFile': {
          'verb':'put','description':'','localName':'outputFile.' + engineAttributes['extension'],'zip':false,'ondemand':false,'required':true
        }
      },
      'settings': {
        'script': {
          'value': engineAttributes['script']
        }
      }
    };
    return this.http
      .post(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/activities', activitySpec ,{ headers: { Authorization: "Bearer " + this.accessToken,
      'Content-Type': 'application/json' }});
  }

  public deleteActivity(id): Observable<any> {
    return this.http
      .delete(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/activities/' + id,{ headers: { Authorization: "Bearer " + this.accessToken,
      'Content-Type': 'application/json' }});
  }

  public createActivityAlias(actname, alias): Observable<any> {
    let aliasSpec = {
      'version': 1,
      'id': alias
    }
    return this.http
      .post(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/activities/' + actname + '/aliases', aliasSpec, { headers: { Authorization: "Bearer " + this.accessToken }});
  }

  public createWorkItem(acid,param): Observable<any> {
    let workItemSpec = {};
    workItemSpec['activityId'] = acid;
    workItemSpec['arguments'] = {};

    let inputFileArgument = {};
    inputFileArgument['url'] = "https://developer.api.autodesk.com/oss/v2/buckets/" + param['bucketKey'] + "/objects/" + param['inputFileNameOSS']
    inputFileArgument['headers'] = {};
    inputFileArgument['headers']['Authorization'] = "Bearer " + this.accessToken;

    let inputJsonArgument = {};
    inputJsonArgument['url'] = 'data:application/json,' + JSON.stringify(param['jsonInput']);

    let dateStr = new Date().getTime().toString();
    // dateStr = dateStr.replace('asd','asd');

    let outputFileNameOSS = dateStr + '_output_' + param['inputFileNameOSS'];
    outputFileNameOSS = param['inputFileNameOSS'];
    let ossOutputUrl = 'https://developer.api.autodesk.com/oss/v2/buckets/' + param['bucketKey'] + '/objects/' + outputFileNameOSS;
    let outputFileArgument = {};
    let outputFilervtArgument = {};
    outputFileArgument['url'] = ossOutputUrl;
    outputFileArgument['headers'] = {};
    outputFileArgument['headers']['Authorization'] = "Bearer " + this.accessToken;
    outputFileArgument['headers']['Content-type'] = "application/octet-stream";
    outputFileArgument['verb'] = 'put';

    outputFilervtArgument['url'] = ossOutputUrl;
    outputFilervtArgument['headers'] = {};
    outputFilervtArgument['headers']['Authorization'] = "Bearer " + this.accessToken;
    outputFilervtArgument['headers']['Content-type'] = "application/octet-stream";
    outputFilervtArgument['verb'] = 'put';

    localStorage.setItem('ossOutputUrl', ossOutputUrl);
    localStorage.setItem('outputFileNameOSS', outputFileNameOSS);

    // outputFileArgument['outputFilervt'] = outputFilervtArgument;

    workItemSpec['arguments']['inputFile'] = inputFileArgument;
    workItemSpec['arguments']['inputJson'] = inputJsonArgument;
    workItemSpec['arguments']['outputFile'] = outputFileArgument;
    // workItemSpec['arguments']['outputFilervt'] = outputFilervtArgument;

    /*workItemSpec['arguments']['rvtFile'] = {
      "url": inputFileArgument['url']
    };
    workItemSpec['arguments']['result'] = {
      "verb": 'put',
      "url": ossOutputUrl
    };*/

    let header = {
      'Authorization': "Bearer " + this.accessToken
    }

    return this.http
      .post(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/workitems', workItemSpec , { headers: header});
  }

  public getWorkItemStatus(wid): Observable<any> {
    let header = {
      'Authorization': "Bearer " + this.accessToken
    }
    return this.http
      .get(RestProvider.BASE_URL + RestProvider.DA_BASE_URL + '/workitems/' + wid, { headers: header });
  }

  public login(username: string, password: any): Observable<any> {
    var formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    // return this.http.post('http://3.15.141.31/login.php', formData, {responseType: 'text'});
    return this.http.post(AWSEC2.LOGIN_URL, {username: encodeURIComponent(username), password: password});
  }
  public users(): Observable<any> {
    let header = {
      'Cache-Control': 'no-cache, max-age=0',
    }
    return this.http.get(AWSEC2.GET_USERS_URL, {headers: header});
  }
  public updateuser(id, username, loginname, loginpass, role, org, bucket, type): Observable<any> {
    var formData = new FormData();
    formData.append('id', id);
    formData.append('username', username);
    formData.append('loginname', loginname);
    formData.append('loginpass', loginpass);
    formData.append('role', role);
    formData.append('org', org);
    formData.append('bucket', bucket);
    formData.append('type', type);
    console.log('came here => ', formData);
    return this.http.put(AWSEC2.UPDATE_USER_URL, { id: id, username: username, loginname: loginname, loginpass: loginpass, role: role, org:org, bucket:encodeURI(bucket), type:type });
  }

  public buckets(): Observable<any> {
    let header = {
      'Cache-Control': 'no-cache, max-age=0',
    }
    return this.http.get(AWSEC2.GET_BUCKETS_URL, {headers: header});
  }
  // public getBucketName(): Observable<any> {
  //   return this.http.get('http://3.15.141.31/getbucketname.php');
  // }

  public updatebucket(bucketid, bucketname, type): Observable<any> {
    return this.http.put(AWSEC2.UPDATE_BUCKET_URL, { id: type == 'update' ? bucketid : this.bucketKey + bucketid, name: bucketname, type:type});
  }
  public getBucketName(bucketid): Observable<any> {
    return this.http.get(AWSEC2.GET_BUCKET_NAME_URL + '?id=' + bucketid);
  }
  public updateUserTime(userId, bucketId, rvt, status, type): Observable<any> {

    var formData = new FormData();
    formData.append('userId', userId);
    formData.append('bucketId', bucketId);
    formData.append('rvt', rvt);
    formData.append('status', status);
    formData.append('type', type);
    console.log(encodeURIComponent(rvt));
    return this.http.put(AWSEC2.UPDATE_USER_TIME_URL, {userid: encodeURIComponent(userId), bucketid:encodeURIComponent(bucketId), rvt:encodeURI(rvt), status:encodeURIComponent(status), type:type});
  }
  public getUserTime(rvt, status): Observable<any> {

    var formData = new FormData();
    formData.append('rvt', rvt);
    formData.append('status', status);
    return this.http.post(AWSEC2.GET_USER_TIME_URL, {rvt:encodeURI(rvt), status:status});
  }
}


// String.prototype.format = function () {
//   var i = 0, args = arguments;
//   return this.replace(/{}/g, function () {
//     return typeof args[i] != 'undefined' ? args[i++] : '';
//   });
// };






// WEBPACK FOOTER //
// ./src/providers/rest/rest.ts